export interface PaginationProps {
    currentPage: number;
    totalPage: number;
    onChange: (page: number) => void;
}

export const InitialPaginationProps: PaginationProps = {
    currentPage: 0,
    totalPage: 0,
    onChange: (): void => {}
}

export interface PaginationPropsForUse {
    currentPage: number;
    totalPage: number;
}

export const InitialPaginationPropsForUse: PaginationPropsForUse = {
    currentPage: 0,
    totalPage: 0
}